module.exports = "form {\n  margin: 50px auto 0 0;\n}\n\n.full-width {\n    display: block;\n    margin: 0 auto;\n    width: 80%;\n    max-width: 500px;\n}\n\n.custom-class {\n  background: green;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/employee-form/employee-form.component.css
// module id = ./src/app/components/employee-form/employee-form.component.css
// module chunks = main